<app-banner></app-banner>
<div class="container">
	<!-- Onglets de navigation -->
	<div class="tabs tabs-lift">
		<label *ngFor="let tab of tabs; let i = index" class="tab !text-[12px]" [class.tab-active]="isTabActive(tab.id)"
			(click)="onTabChange(tab.id)">
			<input type="radio" name="profile_tabs" [checked]="isTabActive(tab.id)" />
			{{ tab.label }}
		</label>
	</div>

	<router-outlet></router-outlet>
</div>